import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component, Fragment } from 'react';
import { DataTicket } from '../../data/DataTicket';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { FicheEvenementHub } from '../Fiche/FicheEvenementHub';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './DetailsListSouhait.css';

export class DetailsListEvenementHub extends Component {

    static defaultProps = {
        idTicket: undefined,
        /* --- */
        onDismiss: () => null,
    };

    static defaultState = {
        itemActif: {},
        items: [],
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        this.state = { ...DetailsListEvenementHub.defaultState };
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des évènements en cours'
        });

        const { idTicket } = this.props;

        DataTicket._chargementDesEvenementsHub(idTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const evenements = responseFetch.reponseAPIobjet || [];
                const state = { items: evenements };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {
        return [{
            key: 'Phase',
            name: 'Phase',
            minWidth: 70,
            maxWidth: 100,
            isResizable: true,
            onRender: (item) => <span title={item.nomPhase}>{item.nomPhase}</span>
        }, {
            key: 'Tache',
            name: 'Tache',
            ariaLabel: 'Tâche',
            minWidth: 70,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => <span title={item.nomTache}>{item.nomTache}</span>
        }, {
            key: 'Detail',
            name: 'Evènement',
            minWidth: 70,
            maxWidth: 200,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => <span title={item.detail}>{item.detail}</span>
        }, {
            key: 'TempsPasse',
            name: 'Temps Passé (min.)',
            fieldName: 'tempsPasse',
            minWidth: 120,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => { return <span title={item.tempsPasse}>{item.tempsPasse}</span>; }
        }, {
            key: 'TempsDebite',
            name: 'Temps Debité (min.)',
            fieldName: 'tempsDebite',
            minWidth: 120,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => <span title={item.tempsDebite}>{item.tempsDebite}</span>
        }, {
            key: 'EmailPersonne',
            name: 'Email Personne',
            fieldName: 'emailPersonne',
            minWidth: 70,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => { return <span title={item.emailPersonne}>{item.emailPersonne}</span>; }
        }, {
            key: 'Statut',
            name: 'Statut',
            fieldName: 'statut',
            minWidth: 70,
            maxWidth: 100,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => { return <span title={item.statut}>{item.statut}</span>; }
        }, {
            key: 'EditionEvenement',
            name: 'EditionEvenement',
            ariaLabel: "Modifier l''évènement",
            minWidth: 20,
            maxWidth: 20,
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                return <IconButton
                    ariaLabel="Edition"
                    iconProps={{ iconName: 'Edit' }}
                    onClick={this._togglePanel("EvenementHub", true, item)}
                    title="Modifier l''évènement"
                />;
            }
        }];
    };

    _getItems = () => {
        return [{
            key: 'nouveau',
            name: 'Nouvel évènement',
            iconProps: { iconName: 'Add' },
            onClick: this._togglePanel("EvenementHub", true)
        }];
    };

    _onColumnHeaderClick = (ev, column) => {
        const columns = this._columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri, pageIndex: 1 },
            this._chargementDonnees
        );
    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
            {defaultRender({
                ...props,
                onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
            })}
        </Sticky>;
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {

        const { idTicket } = this.props;
        const { afficherPanelEvenementHub, itemActif, items } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <DetailsList
                    columns={this._columns}
                    items={items}
                    onColumnHeaderClick={this._onColumnHeaderClick}
                    onRenderDetailsHeader={this._onRenderDetailsHeader}
                    selectionMode={SelectionMode.none}
                />
            </Stack>

            <FicheEvenementHub
                idEvenement={itemActif.idEvenement}
                idTicket={idTicket}
                isOpen={afficherPanelEvenementHub}
                onDismiss={this._togglePanel("EvenementHub", false)}
                onSave={this._togglePanel("EvenementHub", false, {}, this._chargementDonnees)}
            />

        </Fragment>;
    }
}